import { render, staticRenderFns } from "./ViewStage.vue?vue&type=template&id=d047672a"
import script from "./ViewStage.vue?vue&type=script&lang=js"
export * from "./ViewStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports